import { useLocation } from 'react-router';
export const useLocationHref = () => {
    const location = useLocation();
    return `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
};
